<template>
    <section class="streaks">
        <section id="streaks-banner">
            <div class="container">

                <div class="row row-2">
                    <div class="col-12 d-flex justify-content-between align-items-center">
                        <div>
                            <h2>Music Streak</h2>
                            <p>Your music on repeat</p>
                        </div>

                        <div class="profile">
                            <img src="@/assets/images/Ellipse 8.png" alt="">
                            <h4>54K Followers</h4>
                        </div>
                    </div>
                </div>

            </div>
        </section>
        
        <!-- musics section  -->
        <section class="musics">
            <div class="container-large">
                <div class="row">
                    <div class="col-12">
                        <div v-if="loading" class="loader">Loading...</div>
                        <ul class="music-grid" v-else-if="categories.length > 0">
                            <li v-for="category in categories" :key="category.id" class="music-item cat-item" @click="goToCategory(category.id)">
                                <div class="music-item-wrap">
                                    <div class="cat-img-wrap">
                                      <img :src="category.image_url" alt="" class="music-img">
                                    </div>
                                    <h4 class="cat-music-name">{{ category.name }}</h4>
                                    <!-- <p class="music-description">{{ category.description }}</p> -->
                                </div>
                            </li>
                        </ul>
                        <p v-else class="no-data">No data found</p>
                    </div>
                </div>
            </div>
        </section>
    </section>
</template>

<script>
import axios from 'axios';

export default {
    name: 'StreaksMain',
    inject: ['api'],
    props: {
        msg: String
    },
    data() {
        return {
            categories: [], // Store fetched categories
            loading: false // Track loading state
        };
    },
    async mounted() {
        this.loading = true; // Show loader
        try {
            const token = localStorage.getItem('rockstar_token'); // Retrieve user token
            const response = await axios.get(`${this.api.base_url}/category`, {
                headers: {
                  token: this.api.token,
                    'user-token': token // Use user-token instead of Authorization
                }
            });
            this.categories = response.data.data; // Assign API response to categories
        } catch (error) {
            console.error('Error fetching categories:', error);
        } finally {
            this.loading = false; // Hide loader
        }
    },
    methods: {
        goToCategory(categoryId) {
            this.$router.push({ name: 'StreakCategory', params: { categorySlug: categoryId } });
        }
    }
};
</script>

<style scoped>
h3 {
    margin: 40px 0 0;
}
ul {
    list-style-type: none;
    padding: 0;
}
li {
    display: inline-block;
    margin: 0 10px;
}
a {
    color: #42b983;
}
.music-description {
    font-size: 0.9rem;
    color: #666;
}
.loader {
    text-align: center;
    font-size: 1.2rem;
    color: #666;
    margin-top: 20px;
}
</style>